var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support"},[_c('img',{staticClass:"support-flag",attrs:{"src":require("../../public/assets/images/palestine-flag-icon.webp"),"alt":""}}),_c('p',{staticClass:"support-phrase"},[_vm._v(_vm._s(_vm.$t('supportPalestine')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }